export interface FspSegment {
  turnNumberID: number;
  fspTimestamps: number[];
  fspSensorData: ObjectWithBracketKeys;
}

interface ObjectWithBracketKeys {
  [key: string]: any;
}

interface TurnSegment {
  turnNumberID: number;
  timestamps: number[];
  angleData: number[];
}

/**
 * Slice FSP sensor data (multi-spot) into segments aligned with turn segments
 *
 * @param turnSegments - array of turn segments from splitTurns
 * @param fspTimestamps - timestamps of FSP sensor data
 * @param fspData - object with keys = spot IDs, values = arrays of sensor readings
 * @returns array of FSP segments
 */
export function splitFspSegments(turnSegments: TurnSegment[], fspTimestamps: number[], fspData: ObjectWithBracketKeys): FspSegment[] {
  // Ensure all sensor arrays have the same length as timestamps
  const n = fspTimestamps.length;
  // console.log('fspTimestamps length', n, fspData, Object.keys(fspData));
  for (const spotId of Object.keys(fspData)) {
    if (fspData[spotId].length !== n) {
      throw new Error(`fspData for spot ${spotId} has wrong length`);
    }
  }

  const fspSegments: FspSegment[] = [];
  //   console.log('fsptimestamp', fspTimestamps);
  for (const turn of turnSegments) {
    const startTime = turn.timestamps[0];
    const endTime = turn.timestamps[turn.timestamps.length - 1];
    // console.log('startTime, endTime for turn', turn.turnNumberID, startTime, endTime);

    // Build segment data
    const fspTimestampsSegment: number[] = [];
    const fspSensorDataSegment: { [spotId: string]: number[] } = {};
    for (const spotId of Object.keys(fspData)) {
      fspSensorDataSegment[spotId] = [];
    }

    let seenFspTimestamps = new Set<number>();
    for (let i = 0; i < n; i++) {
      if (fspTimestamps[i] >= startTime && fspTimestamps[i] <= endTime) {
        // deduplicate
        if (!seenFspTimestamps.has(fspTimestamps[i])) {
          fspTimestampsSegment.push(fspTimestamps[i]);
          seenFspTimestamps.add(fspTimestamps[i]);
          for (const spotId of Object.keys(fspData)) {
            fspSensorDataSegment[spotId].push(fspData[spotId][i]);
          }
        } else {
          console.log('found timestamp duplicate %d in fspTimestamps, skipping it.', fspTimestamps[i]);
        }
      } else {
        console.log('fspTimestamp not in turnsegment range');
      }
    }

    fspSegments.push({
      turnNumberID: turn.turnNumberID,
      fspTimestamps: fspTimestampsSegment,
      fspSensorData: fspSensorDataSegment,
    });
  }

  return fspSegments;
}
